// extracted by mini-css-extract-plugin
module.exports = {"PageProfileLayout":"PageProfileLayout__PageProfileLayout__2PeeG","avatarWrap":"PageProfileLayout__avatarWrap__2WpkZ","contentWrap":"PageProfileLayout__contentWrap__1ap-R"};